<script>
    import { onMount } from "svelte";
    import MyPageination from "./mypageination.svelte";
    let page_num = 1;
    let per_page = 10;
    let total_count = 0;
    let total_page = Math.ceil(total_count / per_page);
    let list_url = "/dbapi/loglist";
    let count_url = "/dbapi/logcount";
    let ldatas = [];

    // 加载事件函数
    onMount(() => {
        getLogCount();
        readLogList();
    });
    // 切换页面
    function switchPage(topage) {
        page_num = topage;
        readLogList();
    }
    // 取日志总数
    function getLogCount() {
        jQuery.ajax({
            type: "get",
            url: count_url,
            success: function (response) {
                if (response.code == 200) {
                    total_count = response.result;
                    total_page = Math.ceil(total_count / per_page);
                }
            },
            error: function (err) {
                console.log(err);
            },
        });
    }
    // 读取日志列表
    function readLogList() {
        let tmp_url = list_url + "?page=" + page_num + "&count=" + per_page;
        jQuery.ajax({
            type: "get",
            url: tmp_url,
            success: function (response) {
                if (response.code == 200) {
                    if (Array.isArray(response.result)) {
                        ldatas = response.result;
                    }
                }
            },
            error: function (err) {
                console.log(err);
            },
        });
    }
</script>

<!-- Content Wrapper. Contains page content -->
<div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h1>系统日志</h1>
                </div>
                <div class="col-sm-6">
                    <ol class="breadcrumb float-sm-right">&nbsp;</ol>
                </div>
            </div>
        </div>
    </section>
    <!-- Main content -->
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <!-- card -->
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">所有日志</h3>
                            <div class="card-tools">
                                <div
                                    class="input-group input-group-sm"
                                    style="width: 150px;"
                                >
                                    <input
                                        type="text"
                                        name="table_search"
                                        class="form-control float-right"
                                        placeholder="Search"
                                    />
                                    <div class="input-group-append">
                                        <button
                                            type="submit"
                                            class="btn btn-default"
                                        >
                                            <i class="bi bi-search" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <!-- data list-->
                            <div class="row">
                                <table class="table table-bordered table-hover">
                                    <thead class="thead-light">
                                        <tr>
                                            <th width="20%">记录时间</th>
                                            <th width="20%">日志类型</th>
                                            <th width="60%">事件记录</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {#each ldatas as ldata}
                                            <tr>
                                                <td>{ldata.logtime}</td>
                                                <td>{ldata.logtype}</td>
                                                <td>{ldata.loginfo}</td>
                                            </tr>
                                        {/each}
                                    </tbody>
                                </table>
                            </div>
                            <!-- page -->
                            <MyPageination
                                current_page={page_num}
                                page_count={total_page}
                                switch_page_func={switchPage}
                            />
                        </div>
                    </div>
                    <!--/ end of card -->
                </div>
            </div>
        </div>
    </section>
</div>

<style>
</style>
